import { IFilterQueryObject } from '~/src/dash/components/filters/FilterRowV2';

export const convertSetIntoSingleString = (set: Set<string | number>): string => {
  if (set.size !== 1) {
    return '';
  }
  const singleValue = set.values().next().value as string;
  return singleValue;
};

export const convertSetIntoArrayOfStrings = (set: Set<string | number>): Array<string> => {
  return Array.from(set).map((item) => item.toString());
};

export const convertSetIntoArrayOfNumbers = (set: Set<string | number>): Array<number> => {
  return Array.from(set).map((item) => Number(item));
};

export const convertStatusFilterValueIntoString = (set: Set<string | number>): string => {
  if (set.size !== 1) {
    return '';
  }
  const singleValue = set.values().next().value as number;
  return singleValue ? singleValue.toString() : '';
};

export const convertSetIntoSingleNumber = (set: Set<string | number>): number => {
  if (set.size !== 1) {
    return 0;
  }
  const singleValue = set.values().next().value as number;
  return singleValue;
};

export const formatSelectedFiltersIntoQueryObject = (
  selectedFilters: Record<string, Set<string | number>>,
  filtersCfg: Record<string, IFilterQueryObject>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const queryParams: Record<string, any> = {}; // values will vary
  Object.keys(selectedFilters).forEach((key) => {
    const { queryKey, formatQueryValue } = filtersCfg[key];
    queryParams[queryKey] = formatQueryValue(selectedFilters[key]);
  });
  return queryParams;
};
